import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { TLocalization } from '../entities/language.interface';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);
  private readonly apiUrl = this.appConfig.apiUrl;
  private readonly appUrl = this.appConfig.appUrl;

  public getLocalization(): Observable<TLocalization> {
    return this.http.get<TLocalization>(`${this.apiUrl.account_service}/Localization/Detect`);
  }

  public setLanguageInAccountApp(language: string) {
    if (location.href.startsWith(this.appUrl.accounts)) return;
    const iframe = document.createElement('iframe');
    iframe.src = this.appUrl.accounts;
    iframe.style.display = 'none';
    iframe.onload = () => {
      iframe.contentWindow?.postMessage({ language }, this.appUrl.accounts);
      setTimeout(() => document.body.removeChild(iframe));
    }
    document.body.appendChild(iframe);
  }
}
